import { getEditorialAccessMe, getEditorialAccessProfile, putEditorialAccessProfile } from 'app/crud/editorialAccess.crud';
import { isValidAccessMe, isValidProfile, sanitizeData, sanitizeEditorialAccessMe, serializeProfile } from 'app/models/editorialAccess';
import { ApiRequestError, ensureOk } from 'app/services/apiResponse.service';

function read(response, isValid, sanitize, context) {
  const data = response.data?.data;
  if (!isValid(data)) throw new ApiRequestError(response, context);
  return sanitize(data);
}

export async function loadEditorialAccessMe(signal) {
  const response = await ensureOk(getEditorialAccessMe(signal), 'loadEditorialAccessMe');
  return read(response, isValidAccessMe, sanitizeEditorialAccessMe, 'loadEditorialAccessMe');
}

export async function loadEditorialAccessProfile(userGuid, signal) {
  const response = await ensureOk(getEditorialAccessProfile(userGuid, signal), 'loadEditorialAccessProfile');
  if (response.data?.data?.user_guid !== userGuid) throw new ApiRequestError(response, 'loadEditorialAccessProfile: user mismatch');
  return read(response, isValidProfile, sanitizeData, 'loadEditorialAccessProfile');
}

export async function saveEditorialAccessProfile(userGuid, profile) {
  if (!isValidProfile(profile)) throw new Error('EDITORIAL_ACCESS_INVALID_PROFILE');
  await ensureOk(putEditorialAccessProfile(userGuid, serializeProfile(profile)), 'saveEditorialAccessProfile');
  return true;
}
